import { c as _c } from "react/compiler-runtime";
import React, { useState, useEffect } from "react";
import { useDonationTotal, useWidgetSelector } from "../../../../store/store";
import { State } from "../../../../store/state";
import { PaymentInformation } from "./PaymentInformation";
import { Referrals } from "../../../shared/Referrals/Referrals";
import { BankPaymentMethod, WidgetPane3ReferralsProps } from "../../../../types/WidgetProps";
import { ANONYMOUS_DONOR } from "../../../../config/anonymous-donor";
import AnimateHeight from "react-animate-height";
import { usePlausible } from "next-plausible";
import { currencyForLocale } from "../../../../utils/currency";
import panes from "../../Panes.module.scss";
import payment from "../PaymentPane.module.scss";
export const BankPane: React.FC<{
  config: BankPaymentMethod;
  referrals: WidgetPane3ReferralsProps;
}> = t0 => {
  const $ = _c(52);
  const {
    config,
    referrals
  } = t0;
  const plausible = usePlausible();
  const donation = useWidgetSelector(_temp);
  const [hasCompletedTransaction, setHasCompletedTransaction] = useState(false);
  const totalSumIncludingTip = useDonationTotal();
  let t1;
  if ($[0] !== config.locale) {
    t1 = currencyForLocale(config.locale);
    $[0] = config.locale;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const currency = t1;
  let t2;
  if ($[2] !== currency || $[3] !== donation.kid || $[4] !== hasCompletedTransaction || $[5] !== plausible || $[6] !== totalSumIncludingTip) {
    t2 = () => {
      if (hasCompletedTransaction && totalSumIncludingTip && donation.kid) {
        plausible("CompletedDonation", {
          revenue: {
            currency,
            amount: totalSumIncludingTip
          },
          props: {
            method: "bank",
            recurring: false,
            kid: donation.kid
          }
        });
      }
    };
    $[2] = currency;
    $[3] = donation.kid;
    $[4] = hasCompletedTransaction;
    $[5] = plausible;
    $[6] = totalSumIncludingTip;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== hasCompletedTransaction) {
    t3 = [hasCompletedTransaction];
    $[8] = hasCompletedTransaction;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  useEffect(t2, t3);
  const t4 = hasCompletedTransaction ? 0 : "auto";
  let t5;
  if ($[10] !== config.title) {
    t5 = <h2 className={panes.paneTitle}>{config.title}</h2>;
    $[10] = config.title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== config.kid_title || $[13] !== config.kontonr || $[14] !== config.kontonr_title || $[15] !== donation) {
    t6 = <PaymentInformation donation={donation} accountTitle={config.kontonr_title} kidTitle={config.kid_title} accountNr={config.kontonr} />;
    $[12] = config.kid_title;
    $[13] = config.kontonr;
    $[14] = config.kontonr_title;
    $[15] = donation;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== config.explanatory_text) {
    t7 = <div className={payment.infoText}>{config.explanatory_text}</div>;
    $[17] = config.explanatory_text;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== config.explanatory_text_email_template || $[20] !== donation.donor) {
    t8 = donation.donor?.email !== ANONYMOUS_DONOR.email && donation.donor?.email && <div className={payment.infoText}>{config.explanatory_text_email_template.replaceAll("{email}", donation.donor.email)}</div>;
    $[19] = config.explanatory_text_email_template;
    $[20] = donation.donor;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== config.completed_redirect) {
    t9 = () => {
      if (config.completed_redirect && config.completed_redirect.slug) {
        window.open(config.completed_redirect.slug, "_parent");
      } else {
        setHasCompletedTransaction(true);
      }
    };
    $[22] = config.completed_redirect;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== config.button_text || $[25] !== t9) {
    t10 = <div className={payment.completeButtonWrapper}><button className={payment.completeButton} onClick={t9}>{config.button_text}</button></div>;
    $[24] = config.button_text;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t4 || $[29] !== t5 || $[30] !== t6 || $[31] !== t7 || $[32] !== t8) {
    t11 = <AnimateHeight height={t4}>{t5}{t6}{t7}{t8}{t10}</AnimateHeight>;
    $[27] = t10;
    $[28] = t4;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
    $[32] = t8;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  const t12 = hasCompletedTransaction ? "auto" : 0;
  let t13;
  if ($[34] !== config.completed_title) {
    t13 = <h2 className={panes.paneTitle}>{config.completed_title}</h2>;
    $[34] = config.completed_title;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== config.completed_text) {
    t14 = <div className={payment.infoText}>{config.completed_text}</div>;
    $[36] = config.completed_text;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t12 || $[39] !== t13 || $[40] !== t14) {
    t15 = <AnimateHeight height={t12}>{t13}{t14}</AnimateHeight>;
    $[38] = t12;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t11 || $[43] !== t15) {
    t16 = <div>{t11}{t15}</div>;
    $[42] = t11;
    $[43] = t15;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== referrals.other_referral_input_placeholder || $[46] !== referrals.referrals_title || $[47] !== referrals.show_referrals) {
    t17 = !(referrals.show_referrals === false) && <Referrals text={{
      referrals_title: referrals.referrals_title,
      other_referral_input_placeholder: referrals.other_referral_input_placeholder
    }} />;
    $[45] = referrals.other_referral_input_placeholder;
    $[46] = referrals.referrals_title;
    $[47] = referrals.show_referrals;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== t16 || $[50] !== t17) {
    t18 = <div className={panes.pane}><div className={panes.paneContainer}>{t16}{t17}</div></div>;
    $[49] = t16;
    $[50] = t17;
    $[51] = t18;
  } else {
    t18 = $[51];
  }
  return t18;
};
function _temp(state) {
  return state.donation;
}